import { CALL_API } from '../../middlewares/api';
import {
    SEND_INVITATIONS_REQUEST,
    SEND_INVITATIONS_SUCCESS,
    SEND_INVITATIONS_FAILURE,
    SEND_INVITATION_REMINDS_REQUEST,
    SEND_INVITATION_REMINDS_SUCCESS,
    SEND_INVITATION_REMINDS_FAILURE,
    SEND_PURCHASE_REMINDS_REQUEST,
    SEND_PURCHASE_REMINDS_SUCCESS,
    SEND_PURCHASE_REMINDS_FAILURE
} from './constants';
import { HTTP_METHOD_PUT, HTTP_METHOD_POST } from '../../constants/httpMethod';

export const sendInvitations = payload => {
    return {
        [CALL_API]: {
            endpoint: '/user/sponsorship',
            method: HTTP_METHOD_POST,
            types: [SEND_INVITATIONS_REQUEST, SEND_INVITATIONS_SUCCESS, SEND_INVITATIONS_FAILURE],
            body: payload,
            authenticated: true
        }
    };
};

export const sendInvitationReminds = payload => {
    return {
        [CALL_API]: {
            endpoint: '/user/sponsorship',
            method: HTTP_METHOD_PUT,
            types: [
                SEND_INVITATION_REMINDS_REQUEST,
                SEND_INVITATION_REMINDS_SUCCESS,
                SEND_INVITATION_REMINDS_FAILURE
            ],
            body: payload,
            authenticated: true
        }
    };
};

export const sendPurchaseReminds = payload => {
    return {
        [CALL_API]: {
            endpoint: '/user/sponsorship/purchase',
            method: HTTP_METHOD_PUT,
            types: [
                SEND_PURCHASE_REMINDS_REQUEST,
                SEND_PURCHASE_REMINDS_SUCCESS,
                SEND_PURCHASE_REMINDS_FAILURE
            ],
            body: payload,
            authenticated: true
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/sponsorship/actions.js